import * as React from "react";

function projects(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 496 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#prefix__filter0_d_60:474)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M217.664 367.759c15.088-5.275 23.043-21.783 17.768-36.872a28.83 28.83 0 00-12.792-15.48l56.012-19.583 18.091 51.745a28.826 28.826 0 0115.174-12.277c15.089-5.275 31.597 2.68 36.872 17.768 5.275 15.089-2.68 31.597-17.768 36.872a28.822 28.822 0 01-19.518-.148l18.091 51.746-145.705 50.942-50.943-145.706 48.207-16.854a28.827 28.827 0 00-.36 20.079c5.275 15.088 21.783 23.043 36.871 17.768z"
          fill="url(#prefix__paint0_linear_60:474)"
        />
      </g>
      <g filter="url(#prefix__filter1_d_60:474)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M383.648 269.07c3.711-6.524 4.896-14.477 2.671-22.264-4.393-15.368-20.413-24.265-35.782-19.872-15.368 4.393-24.265 20.413-19.872 35.781 2.226 7.786 7.436 13.912 14.034 17.489l-54.731 15.645 15.519 54.289a28.853 28.853 0 0117.173-13.467c15.369-4.393 31.389 4.505 35.782 19.873 4.393 15.368-4.504 31.388-19.873 35.781a28.842 28.842 0 01-21.696-2.356l15.519 54.29 148.41-42.424-42.423-148.41-54.731 15.645z"
          fill="url(#prefix__paint1_linear_60:474)"
        />
      </g>
      <g filter="url(#prefix__filter2_d_60:474)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M207.204 226.625c3.944 15.49 19.698 24.849 35.188 20.905a28.83 28.83 0 0016.533-11.4l14.643 57.503-53.121 13.527a28.817 28.817 0 0110.911 16.183c3.945 15.49-5.415 31.244-20.904 35.188-15.49 3.945-31.244-5.415-35.188-20.904a28.823 28.823 0 011.842-19.431l-53.121 13.527-38.09-149.581 149.581-38.09 12.602 49.488a28.83 28.83 0 00-19.972-2.103c-15.489 3.944-24.849 19.699-20.904 35.188z"
          fill="url(#prefix__paint2_linear_60:474)"
        />
      </g>
      <g filter="url(#prefix__filter3_d_60:474)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M377.805 87.981L234.09 144.297l20.288 51.772a28.83 28.83 0 00-20.653.178c-14.883 5.832-22.219 22.623-16.388 37.506 5.832 14.882 22.624 22.219 37.506 16.387a28.841 28.841 0 0015.276-13.901l20.287 51.772 51.772-20.287a28.834 28.834 0 01-13.901-15.276c-5.831-14.882 1.505-31.674 16.388-37.505 14.882-5.832 31.674 1.505 37.505 16.387a28.83 28.83 0 01.178 20.653l51.772-20.287-19.161-48.899a28.813 28.813 0 01-12.552 9.519c-14.882 5.831-31.674-1.505-37.506-16.388-5.831-14.882 1.505-31.674 16.388-37.505a28.8 28.8 0 0115.677-1.543l-19.161-48.899z"
          fill="url(#prefix__paint3_linear_60:474)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.334 258.465a4.553 4.553 0 10-4.31-8.02 4.553 4.553 0 004.31 8.02zm.647 1.203a5.918 5.918 0 002.41-8.015 5.918 5.918 0 10-10.426 5.605 5.919 5.919 0 008.016 2.41z"
        fill="#D26379"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.647 393.626c3.133-1.685 4.239-5.717 2.47-9.007-1.768-3.289-5.742-4.591-8.875-2.906-3.133 1.684-4.239 5.717-2.47 9.006 1.768 3.29 5.742 4.591 8.875 2.907zm1.325 2.465c4.43-2.382 5.993-8.083 3.493-12.734-2.5-4.651-8.119-6.49-12.548-4.109-4.43 2.382-5.993 8.082-3.493 12.733 2.5 4.651 8.119 6.491 12.548 4.11zM70.685 144.179a6.441 6.441 0 10-6.1-11.346 6.441 6.441 0 006.1 11.346zm1.262 2.347a9.106 9.106 0 003.708-12.332 9.105 9.105 0 00-12.332-3.708 9.105 9.105 0 00-3.708 12.332 9.106 9.106 0 0012.332 3.708zM367.534 28.059c3.133-1.685 4.239-5.717 2.471-9.007-1.769-3.29-5.742-4.59-8.875-2.906-3.134 1.684-4.24 5.716-2.471 9.006 1.769 3.29 5.742 4.591 8.875 2.907zm1.326 2.464c4.429-2.381 5.993-8.082 3.492-12.733-2.5-4.65-8.118-6.49-12.548-4.109-4.429 2.381-5.993 8.082-3.492 12.733 2.5 4.651 8.118 6.49 12.548 4.11z"
        fill="#7053D2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M201.739 77.382c2.215-1.191 3.119-3.814 2.02-5.858-1.099-2.044-3.786-2.736-6-1.546-2.215 1.191-3.119 3.814-2.02 5.858 1.099 2.044 3.785 2.736 6 1.546zm.597 1.11c2.879-1.548 4.055-4.957 2.626-7.615-1.429-2.657-4.921-3.557-7.8-2.01-2.879 1.549-4.055 4.958-2.626 7.616 1.429 2.657 4.921 3.557 7.8 2.01zM149.788 12.43a4.554 4.554 0 00-4.312-8.02 4.554 4.554 0 104.312 8.02zm.646 1.203a5.92 5.92 0 10-5.605-10.427 5.92 5.92 0 005.605 10.427z"
        fill="#D26379"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_60:474"
          x1={179.687}
          y1={493.087}
          x2={278.864}
          y2={284.605}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A28DE9" />
          <stop offset={1} stopColor="#F0EBFF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_60:474"
          x1={330.312}
          y1={444.133}
          x2={328.847}
          y2={248.903}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A28DE9" />
          <stop offset={1} stopColor="#F0EBFF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear_60:474"
          x1={120.41}
          y1={331.861}
          x2={235.478}
          y2={144.052}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A28DE9" />
          <stop offset={1} stopColor="#F0EBFF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear_60:474"
          x1={296.359}
          y1={290.861}
          x2={381.751}
          y2={88.422}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A28DE9" />
          <stop offset={1} stopColor="#F0EBFF" />
        </linearGradient>
        <filter
          id="prefix__filter0_d_60:474"
          x={117.946}
          y={284.824}
          width={247.472}
          height={226.648}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_60:474" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_60:474" result="shape" />
        </filter>
        <filter
          id="prefix__filter1_d_60:474"
          x={274.968}
          y={214.812}
          width={220.834}
          height={248.447}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_60:474" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_60:474" result="shape" />
        </filter>
        <filter
          id="prefix__filter2_d_60:474"
          x={70.897}
          y={133.052}
          width={217.671}
          height={245.382}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_60:474" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_60:474" result="shape" />
        </filter>
        <filter
          id="prefix__filter3_d_60:474"
          x={200.334}
          y={76.981}
          width={248.786}
          height={230.03}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_60:474" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_60:474" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default projects;
